import { Component, OnInit } from '@angular/core';
import { JqueryUtils } from '../../utils/jquery.utils';
import { AccountService } from '../../services/api/account.service';
import { BrokerService } from '../../services/api/broker.service';
import { StrategyService } from '../../services/api/strategy.service';
import { SymbolService } from '../../services/api/symbol.service';
import { ThreadService } from '../../services/api/thread.service';

import { NotificationService } from '../../services/notification.service';
import { CONSTANTS } from '../../constants';
// import { ThemePalette } from '@angular/material/core';
import { DataService } from '../../services/data.service';
import { StrategyHelper } from '../../helpers/strategy';

declare var bootstrap: any
declare var document: any

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

@Component({
  selector: 'app-thread',
  templateUrl: './thread.component.html',
  styleUrls: ['./thread.component.scss']
})
export class ThreadComponent implements OnInit {

  // color: ThemePalette = 'primary';
 
  settings: any;
  admin: any;
  deletion_thread: any = null;

  bas = [];
  strategies: any = [];
  userStrategies: any = [];

  public innerWidth: any;

  users = [CONSTANTS.DEFAULT.USER];
  symbols = [];

  selUser = this.users[0];
  selUserId = this.users[0]._id;

  strategyParams: any = {}
  enableParams: any = { type: '', action: '', action_class: {}, us: null } ;

  constructor(private accountService: AccountService, private brokerService: BrokerService,
    private dataService: DataService, private jq: JqueryUtils, private notificationService: NotificationService,
    private strategyHelper: StrategyHelper, private strategyService: StrategyService, private symbolService: SymbolService,
    private threadService: ThreadService) { }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.THREAD});
    this.settings = {
      singleSelection: true,
      text: "",
      enableSearchFilter: false,
      maxHeight: 250,
      labelKey: 'full_name',
      primaryKey: '_id'
    };
	  this.loadStrategies(false);
    this.loadCategories(false);
    this.loadSegments(false);
    if(this.admin == 'false') {
      this.listUserStrategies();
      this.listUserBrokers(null)
    } else {
      this.listUsers();
    }
    this.dataService.onStrategyDetailsSaved.subscribe(data => {
      this.onStrategySaved(data.success, data.thread);
    });
    this.dataService.onStrategyChanged.subscribe(data => {
      this.populateAddModalParams(data.strategy_name);
    });
  }

  initializeTooltip() {
    const tooltipTriggerList: any = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
  }

  listUsers() {
    this.accountService.listAccounts().subscribe((response: any) => {
      if (response.response_code == 1000) {
        let users = []
        for (let i = 0; i < response.accounts.length; i++) {
          let acc = response.accounts[i]
          users.push({
            _id: acc._id,
            user_id: acc.user._id,
            full_name: acc.user.full_name,
          })
        }
        this.users = users;
        this.selUserId = this.users[0]._id;
        this.onSelUser();
      }
    });
  }

  loadStrategies(force: any) {
    this.strategies = this.dataService.getStrategies();
    if ((this.strategies.length == 0) || force) {
      this.strategyService.listStrategies().subscribe((response: any) => {
        if (response.response_code == 1000) {
          let strategies: any = [CONSTANTS.DEFAULT.STRATEGY]
          for (let i = 0; i < response.strategies.length; i++) {
            let strategy = response.strategies[i]
            strategies.push({
              _id: strategy['_id'],
              name: strategy['name'],
              display_name: strategy['display_name'],
              disabled: false
            })
          }
          this.dataService.setStrategies(strategies);
          this.strategies = strategies;
        }
      });
    }
  }

  loadCategories(force: any) {
    let categories: any = this.dataService.getCategories();
    if ((categories.length == 0) || force) {
      this.symbolService.getCategories().subscribe((response: any) => {
        if (response.response_code == 1000) {
          categories = [CONSTANTS.DEFAULT.CATEGORY]
          for (let i = 0; i < response.categories.length; i++) {
            let category = response.categories[i]
            categories.push({
              _id: category.toLowerCase(),
              name: category,
            })
          }
          this.dataService.setCategories(categories);
        }
      });
    }
  }

  loadSegments(force: any) {
    let segments: any = this.dataService.getSegments();
    if ((segments.length == 0) || force) {
      this.symbolService.getSegments().subscribe((response: any) => {
        if (response.response_code == 1000) {
          let segments = [CONSTANTS.DEFAULT.SEGMENT]
          for (let i = 0; i < response.segments.length; i++) {
            let segment = response.segments[i]
            segments.push({
              _id: segment.toLowerCase(),
              name: segment,
            })
          }
          this.dataService.setSegments(segments);
        }
      });
    }
  }

  listSymbols(data: any, cb: any) {
    this.symbolService.getSymbols(data).subscribe((response: any) => {
      if (response.response_code == 1000) {
        let symbols: any = [CONSTANTS.DEFAULT.SYMBOL];
        for (let i = 0; i < response.symbols.length; i++) {
          let symbol_obj = response.symbols[i];
          symbols.push({
            _id: symbol_obj.trading_symbol.toLowerCase(),
            name: symbol_obj.name,
            trading_symbol: symbol_obj.trading_symbol,
            instrument: symbol_obj.instrument,
            original: symbol_obj,
            disabled: false
          })
        }
        this.symbols = symbols;
        if (cb) {
          cb()
        }
      }
    });
  }

  onSelUser() {
    for (let i = 0; i < this.users.length; i++) {
      if (this.users[i]._id == this.selUserId) {
        this.selUser = this.users[i];
      }
    }
    this.listUserStrategies()
    this.listUserBrokers(this.selUser._id);
  }

  listUserStrategies() {
    let data;
    if(this.admin == 'true'){
       data = {count_per_page:10,page_num:1,acc_id:this.selUser._id,display_for:'web_main_list'}
    }else {
      data = {count_per_page:10,page_num:1,acc_id:sessionStorage.getItem(CONSTANTS.COOKIE.USER_ID),display_for:'web_main_list'}
    }
    this.threadService.list(data).subscribe((response: any) => {
      if (response.response_code == 1000) {
        let threads = response.threads;
        let userStrategies: any = [];
        let us: any;
        for (let idx in threads) {
          us = threads[idx];
          userStrategies.push(this.strategyHelper.toUsRow(us));
        }
        this.userStrategies = userStrategies;
        setTimeout(() => {
          this.initializeTooltip();
        }, 2000);
      }
    });
  }

  listUserBrokers(selected_user_id: any) {
    let data: any = { dt:'list' }
    if (selected_user_id != null) {
      data['acc_id'] = selected_user_id;
    }
    this.brokerService.getUserBrokers(data).subscribe((response: any) => {
      if (response.response_code == 1000) {
        let bas: any = []
        for (let i = 0; i < response.broker_accounts.length; i++) {
          let ba = response.broker_accounts[i]
          bas.push({
            '_id': ba['_id'],
            'name': `${ba["name"]}/${ba["client_id"]}`,
            'original': ba
          })
        }
        this.bas = bas;
      }
    });
  }

  startStop(strategy: any) {
    if (strategy.state == 'stopped') {
      let input = {tid:strategy.id};
      this.threadService.start(input).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Started successfully");
          setTimeout(() => this.listUserStrategies(), 2000);
        } 
      });
    } else if (strategy.state == 'running') {
      let input = {tid:strategy.id};
      this.threadService.stop(input).subscribe((response: any) => {
        if (response.response_code == 1000) {
          if (response.response_code == 1000) {
            this.notificationService.showAlert(CONSTANTS.SUCCESS, "Stopped successfully");
            setTimeout(() => this.listUserStrategies(), 2000);
          }
        }
      });
    }
  }

  restart(strategy: any) { }

  edit(strategy: any) {
    this.populateOpenStrategyModal(strategy, true);
  }

  editDname(us: any) {
    us.dname_edit.mode = true;
  }

  updateDname(us: any) {
    us.dname_edit.mode = true;
    let data = { tid: us.id, display_name: us.dname_edit.text };
    this.threadService.updateDName(data).subscribe((response: any) => {
      if (response.response_code == 1000) {
        let us = response.thread;
        let idx = -1;
        let uss: any = this.userStrategies;
        for (let i = 0; i < uss.length; i++) {
          if (uss[i].id == us._id) {
            idx = i;
            break;
          }
        }
        if (idx > -1) {
          uss[idx] = this.strategyHelper.toUsRow(us);
        }
        this.userStrategies = uss;
      }
    });
  }

  cancelDname(us: any) {
    us.dname_edit.mode = false;
    us.dname_edit.text = us.strategy_name;
  }

  onStrategySaved(success: any, thread: any) {
    if (success) {
      this.jq.closeModal('strategyDetailsModal')
      if (!thread) return;
      let us = thread;
      let idx = -1;
      let uss: any = this.userStrategies;
      for (let i = 0; i < uss.length; i++) {
        if (uss[i].id == us._id) {
          idx = i;
          break;
        }
      }
      if (idx > -1) {
        uss[idx] = this.strategyHelper.toUsRow(us);
      } else {
        uss.push(this.strategyHelper.toUsRow(us));
      }
      this.userStrategies = uss;
    }
  }

  onStatusClick(event: any, us: any) {
    this.jq.openModal('enableConfirmationModal');
    this.enableParams = { 
      type: us.enabled ? 'disable' : 'enable',
      action: us.enabled ? 'Disable' : 'Enable',
      action_class: us.enabled ? { 'btn-danger': 1, 'btn-success': 0 } : { 'btn-danger': 0, 'btn-success': 1 },
      us: us,
      target: event.target
    };
  }

  updateStrategyStatus(confirmation: any, us: any) {
    if (confirmation == 1) {
      let data: any = { tid: us.id, action: us.enabled ? 'disable' : 'enable' };
      this.threadService.action(data).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, `Strategy ${us.enabled ? 'Disabled' : 'Enabled'} Successfully`);
          this.jq.closeModal('enableConfirmationModal')
        }
        this.listUserStrategies();
      });
    } else {
      this.enableParams.target.checked = us.enabled;
      this.enableParams = { type: '', action: '', action_class: {}, us: null } ;
      this.jq.closeModal('enableConfirmationModal')
    }
  }

  onDelete(strategy: any) {
    this.jq.openModal('deleteConfirmationModal');
    this.deletion_thread = strategy;
  }

  deleteStrategy(confirmation: any) {
    if (confirmation == 1) {
      let input = {tid:this.deletion_thread.id};
      this.threadService.deleteThread(input).subscribe((response: any) => {
        if (response.response_code == 1000) {
          if (response.response_code == 1000) {
            this.notificationService.showAlert(CONSTANTS.SUCCESS, "Deleted successfully");
            this.deletion_thread = null;
            this.jq.closeModal('deleteConfirmationModal')
            setTimeout(() => this.listUserStrategies(), 2000);
          }
        }
      });
    } else {
      this.deletion_thread = null;
      this.jq.closeModal('deleteConfirmationModal')
    }
  }

  loadDetails() {
    if(this.admin == 'false') {
      this.listUserStrategies();
      this.listUserBrokers(null)
    } else {
      this.listUsers();
    }
    this.loadStrategies(true);
    this.loadCategories(true);
    this.loadSegments(true);
  }

  openAddModal() {
    this.populateAddModalParams('lss_v1')
  }

  showCopyModal(us: any) {
    this.populateOpenStrategyModal(us, false);
  }

  populateOpenStrategyModal(strategy: any, edit: any) {
    let original = strategy["original"]
    let settings = original["settings"]
    let ip = { category: settings["category"], segment: settings["segment"] }
    this.listSymbols(ip, () => {
      if (!edit) {
        strategy['original']['user'] = this.selUser;
      }
      this.dataService.strategyDetailsOpening({edit:edit, strategy: strategy, bas: this.bas, symbols: this.symbols});
      this.jq.openModal('strategyDetailsModal');
    });
  }

  populateAddModalParams(strategy_name: any) {
    let strategy = this.strategies[0];
    for (let i = 0; i < this.strategies.length; i++) {
      if (this.strategies[i].name.toLowerCase() == strategy_name.toLowerCase()) {
        strategy = this.strategies[i];
        break;
      }
    }
    let ip = { category: "INDEX", segment: "SPOT" };
    this.listSymbols(ip, () => {
      this.dataService.strategyDetailsOpening({edit:false,
        strategy: this.strategyHelper.getDefaultSettings(strategy, this.symbols[1], this.bas[0], this.selUser), bas: this.bas, symbols: this.symbols});
        this.jq.openModal('strategyDetailsModal');
    });
  }
}
